import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { customAvatarAtom, isAuthAtom, myNftAtom, topMessageAtom } from '../../State';
import 'react-loading-skeleton/dist/skeleton.css';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { ReactComponent as AddAvatarSVG } from '../Images/buttons/addAvatarButton.svg';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import isElectron from '../../Global';
import AddAccess from '../Util/AddAccess';
import { ReactComponent as BackArrowSVG } from '../Images/buttons/backArrow.svg';
import { useTranslation } from 'react-i18next';
import NFTMyCustomItem from './NFTMyCustomItem';
import Skeleton from 'react-loading-skeleton';
import NFTItem from './NFTItem';
import EditAvatar from './EditAvatar';

export default function EditDetail({ baseName, selectItem, tapBackArrow }) {
  const { t, i18n } = useTranslation();
  const [customAvatarState, setCustomAvatarState] = useRecoilState(customAvatarAtom);
  const [traitsData, setTraitsData] = useState(null);
  const [pageState, setPageState] = useState('detail');

  //初期化
  useEffect(() => {
    //データ取得
    getData();
  }, []);

  async function getData() {
    let result = await DataModel.getCustomBaseInfo(baseName, i18n.language);

    setTraitsData(result.dataJson);

    // var traits = defaultTraits;
    // traits.base = baseName;
    // setCustomAvatarState(traits);
  }

  //戻るタップ
  const tapBackArrow2 = (status = false) => {
    setPageState('detail');
    //空欄に
    setCustomAvatarState({});

    if (status) {
      tapBackArrow();
    }
  };

  let detailPage = () => {
    return (
      <>
        <div id="nftListTitle" style={{ height: '30px', marginTop: '10px' }}>
          <BackArrowSVG onClick={tapBackArrow} />
          <div>{t('nft.Style Detail')}</div>
          {/* <div>{traitsData != null && traitsData.name != null ? traitsData.name : 'Loading...'}</div> */}
        </div>

        <div className="editAvatarDetailWrap">
          {traitsData != null && traitsData.base != null ? (
            <img src={getImagePath() + '/styles/' + traitsData.base + '.png'} />
          ) : (
            <Skeleton
              baseColor={'#eee'}
              highlightColor={'#fff'}
              height={'123px'}
              width={'100px'}
              borderRadius={'5px'}
            />
          )}

          <div className="editAvatarDetailRight">
            <div className="editAvatarDetailTitle">
              {traitsData != null && traitsData.name != null ? (
                traitsData.name
              ) : (
                <Skeleton
                  baseColor={'#eee'}
                  highlightColor={'#fff'}
                  height={'20px'}
                  width={'200px'}
                  borderRadius={'10px'}
                />
              )}
            </div>
            <div className="editAvatarDetailBody">
              {traitsData != null && traitsData.detail != null ? (
                traitsData.detail
              ) : (
                <>
                  <Skeleton
                    baseColor={'#eee'}
                    highlightColor={'#fff'}
                    height={'10px'}
                    width={'250px'}
                    borderRadius={'5px'}
                  />
                  <Skeleton
                    baseColor={'#eee'}
                    highlightColor={'#fff'}
                    height={'10px'}
                    width={'250px'}
                    borderRadius={'5px'}
                  />
                </>
              )}
            </div>
            {/* <div className="editAvatarDetailTagWrap">
              {traitsData != null && traitsData.tags != null && (
                <>
                  {traitsData['tags'].map((tag, index) => (
                    <div className="editAvatarDetailTag">#{tag}</div>
                  ))}
                </>
              )}
            </div> */}
          </div>
        </div>

        <div className="editDetailWrap">
          <div
            className="editDetailAdd"
            onClick={() => {
              setPageState('edit');
            }}>
            <AddAvatarSVG />
          </div>

          {traitsData != null && (
            <>
              {traitsData['patterns'].map((pattern, index) => (
                <NFTItem
                  id={index}
                  imageURL={'timeless'}
                  thumbURL={'images/nft/thumb/timeless.png'}
                  type={'pro'}
                  nftID={pattern}
                  showType="partnerList"
                  limit="anyone"
                  nftName=""
                />
              ))}
            </>
          )}

          {/* 
          <NFTItem
            imageURL={'timeless'}
            thumbURL={'images/nft/thumb/timeless.png'}
            type={'pro'}
            nftID={'customc95a4dc7-109f-48e3-8946-2b96dbf16e38'}
            showType="partnerList"
            limit="anyone"
            nftName=""
          />

          <NFTItem
            imageURL={'timeless'}
            thumbURL={'images/nft/thumb/timeless.png'}
            type={'pro'}
            nftID={'custom4d777e27-ccdb-4085-bc3a-097fbe1acb58'}
            showType="partnerList"
            limit="anyone"
            nftName=""
          />

          <NFTItem
            imageURL={'timeless'}
            thumbURL={'images/nft/thumb/timeless.png'}
            type={'pro'}
            nftID={'custom9ccded6a-2fac-4314-b58c-6bc1a3edd8c7'}
            showType="partnerList"
            limit="anyone"
            nftName=""
          />

          <NFTItem
            imageURL={'timeless'}
            thumbURL={'images/nft/thumb/timeless.png'}
            type={'pro'}
            nftID={'customab7b089e-d575-4a73-86be-90292fc5a7ea'}
            showType="partnerList"
            limit="anyone"
            nftName=""
          />

          <NFTItem
            imageURL={'timeless'}
            thumbURL={'images/nft/thumb/timeless.png'}
            type={'pro'}
            nftID={'custom95985a60-9cd1-449d-ab51-bbc07035f729'}
            showType="partnerList"
            limit="anyone"
            nftName=""
          /> */}
        </div>

        <div className="nftListTitle4">{t('nft.Background')}</div>

        <div className="renew">
          <div className="nftBackgroundList">
            <NFTItem imageURL={'whiteYellow.png'} type={'back'} />
            <NFTItem imageURL={'c1.png'} type={'back'} />
          </div>
        </div>
      </>
    );
  };

  if (pageState == 'detail') {
    return detailPage();
  } else {
    return <EditAvatar baseName={baseName} tapBackArrow={tapBackArrow2} traitsData={traitsData} />;
  }
}
